// import React from 'react';
// import { GoogleLogin } from '@react-oauth/google';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios'; // FIXED: Use Axios to use global Base URL

// const LoginPage = ({ setUser, setRole }) => {
//   const navigate = useNavigate();

//   const handleSuccess = async (credentialResponse) => {
//     try {
//       // FIXED: Use axios.post() with relative path. 
//       // It automatically uses the Cloud URL from index.js
//       const res = await axios.post('/api/auth/google', { 
//         token: credentialResponse.credential 
//       });

//       const data = res.data; // Axios returns data in .data

//       // Save to Local Storage
//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user)); 
//       localStorage.setItem('role', data.role); 

//       // Update App State
//       if (setUser) setUser(data.user);
//       if (setRole) setRole(data.role);

//       // Redirect based on role
//       if (data.role === 'ADMIN') {
//           navigate('/admin');
//       } else {
//           navigate('/customer'); 
//       }

//     } catch (err) {
//       console.error('Login Error:', err);
//       // specific error message from backend or generic one
//       const msg = err.response?.data?.message || err.message;
//       alert('Login Failed: ' + msg);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50 font-sans">
//       <div className="bg-white p-10 rounded-xl shadow-2xl max-w-sm w-full text-center">
//         <div className="text-5xl mb-6">🌳</div>
//         <h1 className="text-2xl font-bold text-gray-800 mb-2">Welcome</h1>
//         <p className="text-gray-500 mb-8">Sign in to access the Family Chronicle.</p>
//         <div className="flex justify-center mb-6">
//           <GoogleLogin
//             onSuccess={handleSuccess}
//             onError={() => alert("Google Login Failed")}
//             theme="filled_blue"
//             shape="pill"
//             size="large"
//             text="continue_with"
//             useOneTap 
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;



































// import React from 'react';
// import { GoogleLogin } from '@react-oauth/google';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios'; // FIXED: Use Axios to use global Base URL

// const LoginPage = ({ setUser, setRole }) => {
//   const navigate = useNavigate();

//   const handleSuccess = async (credentialResponse) => {
//     try {
//       // FIXED: Use axios.post() with relative path. 
//       // It automatically uses the Cloud URL from index.js
//       const res = await axios.post('/api/auth/google', { 
//         token: credentialResponse.credential 
//       });

//       const data = res.data; // Axios returns data in .data

//       // Save to Local Storage
//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user)); 
//       localStorage.setItem('role', data.role); 

//       // Update App State
//       if (setUser) setUser(data.user);
//       if (setRole) setRole(data.role);

//       // Redirect based on role
//       if (data.role === 'ADMIN') {
//           navigate('/admin');
//       } else {
//           navigate('/customer'); 
//       }

//     } catch (err) {
//       console.error('Login Error:', err);
//       // specific error message from backend or generic one
//       const msg = err.response?.data?.message || err.message;
//       alert('Login Failed: ' + msg);
//     }
//   };

//   return (
//     <div className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 font-sans p-6">
//       <div className="bg-white p-10 md:p-12 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-white max-w-md w-full text-center transform transition-all hover:-translate-y-1">
        
//         {/* Icon / Avatar Area */}
//         <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-8 shadow-inner">
//             <span className="text-4xl">🌳</span>
//         </div>

//         <h1 className="text-3xl font-extrabold text-gray-900 mb-3 tracking-tight">Welcome Back</h1>
//         <p className="text-gray-500 mb-10 text-sm font-medium">Sign in securely to access the Family Chronicle and continue exploring your lineage.</p>
        
//         <div className="flex justify-center mb-4">
//           <div className="p-1 rounded-full bg-white shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
//               <GoogleLogin
//                 onSuccess={handleSuccess}
//                 onError={() => alert("Google Login Failed")}
//                 theme="filled_blue"
//                 shape="pill"
//                 size="large"
//                 text="continue_with"
//                 useOneTap 
//               />
//           </div>
//         </div>

//         <div className="mt-8 text-xs text-gray-400 font-medium">
//             Protected by Google standard authentication.
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;























// import React from 'react';
// import { GoogleLogin } from '@react-oauth/google';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const LoginPage = ({ setUser, setRole }) => {
//   const navigate = useNavigate();

//   const handleSuccess = async (credentialResponse) => {
//     try {
//       const res = await axios.post('/api/auth/google', { 
//         token: credentialResponse.credential 
//       });

//       const data = res.data; 

//       // Save to Local Storage
//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user)); 
//       localStorage.setItem('role', data.role); 

//       // Update App State
//       if (setUser) setUser(data.user);
//       if (setRole) setRole(data.role);

//       // Redirect based on role
//       if (data.role === 'ADMIN') {
//           navigate('/admin');
//       } else {
//           navigate('/customer'); 
//       }

//     } catch (err) {
//       console.error('Login Error:', err);
//       const msg = err.response?.data?.message || err.message;
//       alert('Login Failed: ' + msg);
//     }
//   };

//   return (
//     <div className="min-h-[calc(100vh-80px)] flex items-center justify-center bg-slate-50 font-sans p-6">
//       <div className="bg-white p-10 md:p-12 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100 max-w-md w-full text-center">
        
//         {/* Icon Area */}
//         <div className="w-20 h-20 bg-blue-50/50 rounded-full flex items-center justify-center mx-auto mb-8 shadow-inner border border-blue-100">
//             <span className="text-4xl">🌳</span>
//         </div>

//         <h1 className="text-3xl font-extrabold text-slate-900 mb-3 tracking-tight">Welcome Back</h1>
//         <p className="text-slate-500 mb-10 text-sm font-medium leading-relaxed">
//           Sign in securely to access the Family Chronicle and continue exploring your lineage.
//         </p>
        
//         <div className="flex justify-center mb-6">
//           <div className="p-1 rounded-full bg-white shadow-sm border border-slate-200 hover:shadow-md transition-shadow duration-300">
//               <GoogleLogin
//                 onSuccess={handleSuccess}
//                 onError={() => alert("Google Login Failed")}
//                 theme="filled_blue"
//                 shape="pill"
//                 size="large"
//                 text="continue_with"
//                 useOneTap 
//               />
//           </div>
//         </div>

//         <div className="mt-8 text-xs text-slate-400 font-medium">
//             Protected by Google standard authentication.
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;
























import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const LoginPage = ({ setUser, setRole }) => {
  const navigate = useNavigate();

  const handleSuccess = async (credentialResponse) => {
    try {
      const res = await axios.post('/api/auth/google', { 
        token: credentialResponse.credential 
      });

      const data = res.data; 
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user)); 
      localStorage.setItem('role', data.role); 

      if (setUser) setUser(data.user);
      if (setRole) setRole(data.role);

      if (data.role === 'ADMIN') {
          navigate('/admin');
      } else {
          navigate('/customer'); 
      }
    } catch (err) {
      console.error('Login Error:', err);
      const msg = err.response?.data?.message || err.message;
      alert('Login Failed: ' + msg);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center bg-gray-50 font-sans p-6">
      <div className="bg-white p-10 md:p-12 rounded-2xl shadow-xl border border-gray-100 max-w-md w-full text-center">
        
        <div className="text-5xl mb-6">🌳</div>

        <h1 className="text-3xl font-extrabold text-gray-900 mb-3 tracking-tight">Sign In</h1>
        <p className="text-gray-500 mb-10 text-sm font-medium">
          Securely access the Family Chronicle to explore your lineage.
        </p>
        
        <div className="flex justify-center mb-6">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => alert("Google Login Failed")}
            theme="outline"
            shape="rectangular"
            size="large"
            text="continue_with"
            useOneTap 
          />
        </div>

      </div>
    </div>
  );
};

export default LoginPage;